import { classNames, tv } from "@opensea/ui-kit"

export const sidePanelVariants = tv({
  base: "scrollbar-hidden overflow-x-visible overflow-y-scroll",
  variants: {
    page: {
      collection: "",
      profile: "",
      portfolio: "pt-1",
      activity: "pt-4",
      stats: "pt-4",
      studio: "pt-4",
      watchlist: "pt-3",
      "token-watchlist": "pt-3",
      created: "",
      token: "pt-4",
    },
    type: {
      filter: "",
      module: "",
    },
    actionBar: {
      true: "",
      false: "",
    },
  },
  defaultVariants: {
    actionBar: false,
  },
  compoundVariants: [
    {
      page: ["collection", "profile", "portfolio"],
      actionBar: false,
      className: classNames(
        "h-[calc(100vh-theme(spacing.sm-top-nav)-theme(spacing.hero-header-compact)-theme(spacing.14)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
        "lg:h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.hero-header-compact)-theme(spacing.14)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
      ),
    },
    {
      page: ["collection", "profile", "portfolio"],
      actionBar: true,
      className: classNames(
        "h-[calc(100vh-theme(spacing.sm-top-nav)-theme(spacing.hero-header-compact)-theme(spacing.14)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
        "lg:h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.hero-header-compact)-theme(spacing.14)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
        "pb-[theme(spacing.bottom-action-bar)]",
      ),
    },
    {
      page: ["activity", "stats", "watchlist", "token-watchlist", "token"],
      className: classNames(
        "h-[calc(100vh-theme(spacing.sm-top-nav)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
        "lg:h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom))]",
      ),
    },
    {
      page: "studio",
      className: classNames(
        "h-[calc(100vh-theme(spacing.sm-top-nav)-theme(spacing.pwa-banner-offset)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom)-70px)]",
        "lg:h-[calc(100vh-theme(spacing.lg-top-nav)-theme(spacing.pwa-banner-offset)-theme(spacing.page-footer)-theme(spacing.ios-inset-bottom)-70px)]",
      ),
    },
    {
      page: "collection",
      type: "module",
      class: "pb-0",
    },
  ],
})

export const HIGH_ITEM_COUNT_THRESHOLD = 1000
